import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { MainService } from 'src/app/services/main/main.service';
import { environment } from 'src/environments/environment';
import { setUserProfiles } from 'src/app/core/session';

@Component({
    selector: 'app-migrate',
    templateUrl: './migrate.component.html',
    styleUrls: ['./migrate.component.scss']
})
export class MigrateComponent implements OnInit {
    public queryParamSubscription;
    user = localStorage.getItem('user');
    constructor(public _routes: ActivatedRoute, private router: Router, public authService: AuthService, public _main: MainService) {
        localStorage.removeItem('token');
        localStorage.removeItem('environment');
        localStorage.removeItem('userProfileData');
        localStorage.removeItem('timezone');
        localStorage.removeItem('recurring_extra_amount');
        localStorage.removeItem('fixed_flat_fee');
        localStorage.removeItem('locations');
        localStorage.removeItem('departments');
        localStorage.removeItem('roleId');
        localStorage.removeItem('ppViewMode');
        localStorage.removeItem('arViewMode');
        localStorage.removeItem('viewMode');
        localStorage.removeItem('globalFilter');
        localStorage.removeItem('reset_email');
    }

    ngOnInit() {
        this.queryParamSubscription = this._routes.queryParams
            .subscribe(params => {
                if (params.ac_tk || params.t) {
                    // if (params.type == 'business') {
                    localStorage.setItem('token', params.ac_tk || params.t);
                    let data = {
                        device_type: environment.device_type,
                        app_type: environment.app_type,
                        app_version: environment.app_version,
                        device_token: environment.device_token,
                        device_id: this.user,
                        access_token: params.ac_tk || params.t,
                        environment: environment.env,
                        navigate_to_dashboard: 1,
                    };
                    this.authService.http.post<any>(environment.baseUrl + 'access_token_login', data, { headers: this.authService.headers })
                        .subscribe((response: any) => {
                            if (response && response.is_error) {
                                localStorage.removeItem('token');
                                this.router.navigate(['login']);
                            } else {
                                if (response.flag === 116) {
                                    localStorage.setItem('reset_password_token', response.reset_password_token);
                                    this.router.navigate(['new-password']);
                                } else if (response.flag === 4 || response.flag === 309) {
                                    localStorage.removeItem('token');
                                    this.router.navigate(['login']);
                                } else {
                                    if (response.profile) {
                                        setUserProfiles(response.profile);
                                        this.authService.userProfileData$.next(response.profile);
                                    } else if (response.doctor_profile) {
                                        setUserProfiles(response.doctor_profile);
                                        this.authService.userProfileData$.next(response.doctor_profile);
                                    }
                                    if (response.menu) {
                                        this._main.available_menu.next(response.menu);
                                    }
                                    this.authService.setLoginData(response);
                                }
                            }
                        })
                    // } else if (params.type == 'enterprise') {
                    //     localStorage.setItem('token', params.ac_tk);
                    //     let data = {
                    //         access_token: params.ac_tk
                    //     };
                    //     this._main.api(data, 'upgrade_business_to_enterprise', false)
                    //         .subscribe((response: any) => {
                    //             if (response.is_error == 0) {
                    //                 this._main.available_menu.next(response.menu);
                    //                 this.authService.setLoginData(response);
                    //             } else {
                    //                 this._main.customPopups(response.override_text || response.error || response.err, 1);
                    //             }
                    //         })
                    // } else {
                    //     this.router.navigate(['/app/dashboard']);
                    // }
                } else {
                    this.router.navigate(['/app/finance-customer']);
                }
            });
    }

}
